import * as Tone from 'tone';
import AudioChain from './AudioChain';
class Master {
    constructor() {
        this.chain = new AudioChain();
        this.input = this.chain.input();
        this.output = new Tone.Gain(0, "decibels").toDestination();
        this.chain.output().connect(this.output);
    }
    insert(object, position) {
        this.chain.insert(object, position);
    }
}
export default Master;
//# sourceMappingURL=Master.js.map